// ============================================
// SplashScreen - full-viewport loading overlay shown on app boot
// ============================================
// Covers the initial layout while the dashboard's component tree fills
// in (profile avatar, bell, top bar, page content). Without this, the
// user sees the top bar icons pop in first, then the rest of the page
// shift as each data query resolves. The splash holds the viewport
// stable for a minimum duration then fades out, so layout shifts
// happen out-of-sight.
// ============================================

import React, { useEffect, useState } from 'react';

interface SplashScreenProps {
  /** Minimum time to show the splash, in ms. Defaults to 1800 so users
   * see at least one full cycle of the breathing animation. */
  minDuration?: number;
}

export const SplashScreen: React.FC<SplashScreenProps> = ({ minDuration = 1800 }) => {
  const [visible, setVisible] = useState(true);
  const [mounted, setMounted] = useState(true);

  useEffect(() => {
    const fadeTimer = window.setTimeout(() => setVisible(false), minDuration);
    return () => window.clearTimeout(fadeTimer);
  }, [minDuration]);

  useEffect(() => {
    if (visible) return;
    // Wait for the fade to finish before unmounting.
    const unmountTimer = window.setTimeout(() => setMounted(false), 420);
    return () => window.clearTimeout(unmountTimer);
  }, [visible]);

  if (!mounted) return null;

  return (
    <div
      className={`splash-screen${visible ? '' : ' splash-screen-hiding'}`}
      aria-hidden="true"
    >
      <div className="splash-mark">
        <img
          src="/images/PRTCL%20Logo%20(icon)%20-%20white.png"
          alt=""
          className="splash-mark-img"
          draggable={false}
        />
      </div>
    </div>
  );
};

export default SplashScreen;
